// [REFACTOR NOTE] It would be cleaner to have a single source of truth for state,
// and to have the helpers access that instead of the global variables directly.
window.helpers = window.helpers || {};

import './handlebars-helpers-data';
import './handlebars-helpers-control';
import './handlebars-helpers-format';
